import { h, mount, errMsg } from '../ui/dom';
import { api, login } from '../api';

/** Đăng nhập / đăng ký / quên mật khẩu. Trả về khi đăng nhập thành công. */
export function authScreen(initial: 'login' | 'register'): Promise<void> {
  return new Promise((resolve) => {
    let mode: 'login' | 'register' | 'forgot' = initial;
    const err = h('div', { class: 'err', role: 'alert' });
    const email = h('input', { type: 'email', id: 'email', autocomplete: 'email', required: true, inputmode: 'email' });
    const pass = h('input', { type: 'password', id: 'password', autocomplete: 'current-password', required: true, minlength: '8' });
    const submit = h('button', { class: 'btn gold', type: 'submit', style: 'width:100%' });
    const passField = h('div', { class: 'field' }, h('label', { for: 'password' }, 'Mật khẩu'), pass);
    const hint = h('p', { class: 'muted small-t' });
    const tabs = h('div', { class: 'tabs', role: 'tablist' });
    const forgotLink = h('button', { class: 'link', type: 'button', onClick: () => set('forgot') }, 'Quên mật khẩu?');
    const set = (m: typeof mode) => {
      mode = m; err.textContent = '';
      tabs.replaceChildren(...(['login', 'register'] as const).map((k) => h('button', { type: 'button', class: mode === k ? 'on' : '', role: 'tab', onClick: () => set(k) }, k === 'login' ? 'Đăng nhập' : 'Tạo tài khoản')));
      passField.classList.toggle('hidden', mode === 'forgot'); pass.required = mode !== 'forgot';
      pass.autocomplete = mode === 'register' ? 'new-password' : 'current-password';
      submit.textContent = mode === 'login' ? 'Bước vào' : mode === 'register' ? 'Tạo tài khoản' : 'Gửi hướng dẫn';
      hint.textContent = mode === 'register' ? 'Mật khẩu tối thiểu 8 ký tự, gồm chữ và số.' : mode === 'forgot' ? 'Nhập email đã đăng ký để nhận liên kết đặt lại mật khẩu.' : '';
      forgotLink.classList.toggle('hidden', mode !== 'login');
    };
    const form = h('form', { onSubmit: async (e: Event) => {
      e.preventDefault(); err.textContent = ''; submit.disabled = true;
      try {
        if (mode === 'forgot') { const r = await api<{ message: string }>('/auth/forgot-password', { body: { email: email.value } }); err.textContent = r.message; return; }
        await login(email.value, pass.value, mode === 'register'); resolve();
      } catch (ex) { err.textContent = errMsg(ex); } finally { submit.disabled = false; }
    } }, h('div', { class: 'field' }, h('label', { for: 'email' }, 'Email'), email), passField, hint, err, submit, h('div', { style: 'text-align:center;margin-top:8px' }, forgotLink));
    mount(h('div', { class: 'screen', style: 'background:radial-gradient(ellipse at 50% 30%,#3a1410,#0c0607 70%)' },
      h('div', { class: 'panel modal' }, h('h1', { style: 'text-align:center;color:var(--gold)' }, 'Cổng U Minh'), h('div', { class: 'ornament' }), tabs, form)));
    set(mode); email.focus();
  });
}
